import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TacticType } from "@front/m19-api-client";
import { SegmentEx, StrategyEx, StrategyGroupEx } from "@front/m19-models";
import { TranslocoDirective } from "@jsverse/transloco";
import { IBadgeComponent } from "@front/m19-ui";

@Component({
  selector: "app-strategy-grid-tactic",
  imports: [TranslocoDirective, IBadgeComponent],
  template: `
    <div class="flex gap-1" *transloco="let t">
      @if (strategyGroup(); as strategyGroup) {
        @if (strategyGroup.brandStrategies.length > 0) {
          <IBadge
            color="white"
            [label]="t('strategy-table.strat_n_brand_defense', [strategyGroup.brandStrategies.length])"
          ></IBadge>
        }
        @if (strategyGroup.keywordStrategies.length > 0) {
          <IBadge
            color="white"
            [label]="t('strategy-table.strat_n_focus', [strategyGroup.keywordStrategies.length])"
          ></IBadge>
        }
        <IBadge
          color="white"
          [label]="t('strategy-table.strat_n_main', [strategyGroup.productStrategies.length])"
        ></IBadge>
      } @else {
        @if (blacklistTacticsCount()) {
          <IBadge
            color="white"
            [label]="
              t('tactic-strategy-renderer.numblacklist_blacklist_tactics', {
                count: blacklistTacticsCount(),
              })
            "
          />
        }
        @if (legacyTacticsCount()) {
          <IBadge
            color="white"
            [label]="
              t('tactic-strategy-renderer.numlegacy_legacy_tactic', {
                count: legacyTacticsCount(),
              })
            "
          />
        }
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyGridTacticComponent {
  strategy = input<StrategyEx>();
  strategyGroup = input<StrategyGroupEx>();
  segmentIndex = input.required<Map<number, SegmentEx>>();
  blacklistTacticsCount = computed(() => {
    const strategy = this.strategy();
    return strategy && strategy.isAdvertisingStrategy()
      ? strategy.tactics.filter((t) => t.tacticType == TacticType.BLACKLIST).length
      : 0;
  });
  legacyTacticsCount = computed(() => {
    const strategy = this.strategy();
    return strategy && strategy.isAdvertisingStrategy()
      ? strategy.tactics.filter((t) => t.tacticType == TacticType.LEGACY).length
      : 0;
  });
}
